import { render, staticRenderFns } from "./PayslipView.vue?vue&type=template&id=c17fffce&"
import script from "./PayslipView.vue?vue&type=script&lang=js&"
export * from "./PayslipView.vue?vue&type=script&lang=js&"
import style0 from "./PayslipView.vue?vue&type=style&index=0&id=c17fffce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports